import { cva } from "class-variance-authority"

// TODO: add variants based on Card variants for interactive card not being of variant "surface"
export const interactiveCardCva = cva(["select-none", "transition-[box-shadow]", "hover:inset-ring-(--base-a7)"])

export const interactiveTextCva = cva(["hover:underline"])
